{
  "WHATSAPP_TEMPLATES": {
    "MODAL": {
      "TITLE": "Whatsapp sablonok",
      "SUBTITLE": "Válaszd ki a Whatsapp sablont",
      "TEMPLATE_SELECTED_SUBTITLE": "Configure template: {templateName}"
    },
    "PICKER": {
      "SEARCH_PLACEHOLDER": "Sablon keresése",
      "NO_TEMPLATES_FOUND": "Nem található sablon erre:",
      "HEADER": "Header",
      "BODY": "Body",
      "FOOTER": "Footer",
      "BUTTONS": "Buttons",
      "CATEGORY": "Kategória",
      "MEDIA_CONTENT": "Media Content",
      "MEDIA_CONTENT_FALLBACK": "media content",
      "NO_TEMPLATES_AVAILABLE": "No WhatsApp templates available. Click refresh to sync templates from WhatsApp.",
      "REFRESH_BUTTON": "Refresh templates",
      "REFRESH_SUCCESS": "Templates refresh initiated. It may take a couple of minutes to update.",
      "REFRESH_ERROR": "Failed to refresh templates. Please try again.",
      "LABELS": {
        "LANGUAGE": "Nyelv",
        "TEMPLATE_BODY": "Sablon törzse",
        "CATEGORY": "Kategória"
      }
    },
    "PARSER": {
      "VARIABLES_LABEL": "Változók",
      "LANGUAGE": "Nyelv",
      "CATEGORY": "Kategória",
      "VARIABLE_PLACEHOLDER": "Add meg a {variable} értékét",
      "GO_BACK_LABEL": "Vissza",
      "SEND_MESSAGE_LABEL": "Üzenet küldése",
      "FORM_ERROR_MESSAGE": "Kérlek add meg az összes változó értékét küldés előtt",
      "MEDIA_HEADER_LABEL": "{type} Header",
      "OTP_CODE": "Enter 4-8 digit OTP",
      "EXPIRY_MINUTES": "Enter expiry minutes",
      "BUTTON_PARAMETERS": "Button Parameters",
      "BUTTON_LABEL": "Button {index}",
      "COUPON_CODE": "Enter coupon code (max 15 chars)",
      "MEDIA_URL_LABEL": "Enter {type} URL",
      "DOCUMENT_NAME_PLACEHOLDER": "Enter document filename (e.g., Invoice_2025.pdf)",
      "BUTTON_PARAMETER": "Enter button parameter"
    }
  }
}
